import { PulseTemplateLifecycleSurveysApi } from 'api/PulseTemplateLifecycleSurveysApi';
import { backendApiClient } from 'container/backendApiClient';

export const pulseTemplateLifecycleSurveysApi = new PulseTemplateLifecycleSurveysApi(
  backendApiClient,
);
